import type { ArrayFilter } from '@quromedical/utils';

type AlwaysTrue = () => true;

const keepAll: AlwaysTrue = () => true;

/**
 *
 * @param filters filters to use for when the name is a provided filter
 * @param fallback the filter to use if the given filter is not defined, default `AlwaysTrue`
 * @returns a function that returns a filter based on the name
 *
 * @example
 * const filter = createNamedFilter({
 *  foo: (item) => item.name === 'foo',
 *  bar: (item) => item.name === 'bar',
 * });
 *
 * const fooItems = items.filter(filter('foo'));
 */
export const createNamedFilter =
  <T, TName extends string = string>(
    filters: Partial<Record<TName, ArrayFilter<T>>>,
    fallback: ArrayFilter<T> = keepAll,
  ) =>
  (name?: TName): ArrayFilter<T> => {
    if (!name) {
      return fallback;
    }

    const filter = filters[name];
    return filter || fallback;
  };
